export interface iCheckoutOrderReview {
  purchaseOrderNumber?: string;
  requestedDeliveryDate?: string;
  deliveryAddress?: iShippingAddressArray | any;
}
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { iShippingAddressArray } from 'src/app/spartacus/commonComponents/cart/cart.model';
import { OrderService } from '../service/order.service';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss'],
})
export class OrderDetailsComponent implements OnInit {
  orderData: any;
  shiptoObj: iCheckoutOrderReview = {};
  constructor(
    public orderService: OrderService,
    public cd: ChangeDetectorRef,
    public route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.orderService.$orderDetailsResponse.subscribe((orderData) => {
      if (orderData) {
        this.processOrderData(orderData);
      } else {
        let orderID = this.route.snapshot.queryParamMap.get('orderId') || 'sampleorderId';
        if (orderID) {
          this.orderService.getOrderDetails(orderID).subscribe((orderData) => {
            this.processOrderData(orderData);
            this.cd.detectChanges();
          });
        }
      }
      this.cd.detectChanges();
    });
  }

  processOrderData(orderData: any) {
    this.orderData = orderData;
    let delivery_date = orderData.expectedDeliveryDate?.split('T')[0]
      ? orderData.expectedDeliveryDate?.split('T')[0]
      : '';
    this.shiptoObj = {
      deliveryAddress: orderData.deliveryAddress,
      purchaseOrderNumber: orderData?.purchaseOrderNumber,
      requestedDeliveryDate: delivery_date,
    };
  }
}
